document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".video-or-image-container");

  containers.forEach((container) => {
    const video = container.querySelector("video");
    const controlButton = container.querySelector(".video-control-button");
    const controlIcon = controlButton?.querySelector(".control-icon");

    // Defensive: ensure all required elements are present and avoid duplicate listeners
    if (!container.dataset.listenerAttached && video && controlButton && controlIcon) {
      container.dataset.listenerAttached = "true";

      controlButton.addEventListener("click", function (e) {
        e.stopPropagation();
        video.paused ? video.play() : video.pause();
      });

      video.addEventListener("click", function (e) {
        if (e.target.closest(".video-control-button")) return;
        if (!video.paused) video.pause();
      });

      video.addEventListener("play", function () {
        controlIcon.classList.add("hidden");
      });

      video.addEventListener("pause", function () {
        controlIcon.classList.remove("hidden");
      });

      // Currently this function is optional because of video is playing in loop 
      video.addEventListener("ended", function () {
        controlIcon.classList.remove("hidden");
      });
    }
  });
});
